var blockquote_default = {
  "fontElementMap": "li6uw",
  "quote": "_5-ovX"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
